import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import CryptoIcon from './CryptoIcons';
import './CryptoTicker.css';

interface CryptoPrice {
  symbol: string;
  price: number;
  change24h: number;
}

interface CoinData {
  id: string;
  current_price: number;
  price_change_percentage_24h: number;
}

type CoinMapping = {
  [key: string]: string;
};

const CryptoTicker: React.FC = () => {
  const [prices, setPrices] = useState<CryptoPrice[]>([]);
  const symbols = ['BTC', 'ETH', 'XRP', 'SOL', 'MATIC'];

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await fetch(
          'https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=bitcoin,ethereum,ripple,solana,matic-network&order=market_cap_desc&per_page=5&page=1&sparkline=false&price_change_percentage=24h'
        );
        const data = await response.json();
        
        // Create a mapping of coin IDs to their respective symbols
        const coinMapping: CoinMapping = {
          'bitcoin': 'BTC',
          'ethereum': 'ETH',
          'ripple': 'XRP',
          'solana': 'SOL',
        };
        
        // Process data more efficiently
        const formattedPrices: CryptoPrice[] = data
          .filter((coin: CoinData) => coin.id && coinMapping[coin.id])
          .map((coin: CoinData) => ({
            symbol: coinMapping[coin.id],
            price: Number(coin.current_price) || 0,
            change24h: Number(coin.price_change_percentage_24h) || 0
          }))
          .filter((price: CryptoPrice) => price.price > 0);
        
        setPrices(formattedPrices);
      } catch (error) {
        console.error('Error fetching crypto prices:', error);
        // Fallback to empty prices but don't crash
        setPrices([]);
      }
    };

    fetchPrices();
    const interval = setInterval(fetchPrices, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="crypto-ticker">
      <Container className="ticker-container">
        <div className="ticker-wrap">
          <div className="ticker-move">
            {/* Duplicate the items to create a seamless loop */}
            {[...prices, ...prices].map((crypto, index) => (
              <div key={`${crypto.symbol}-${index}`} className="ticker-item">
                <CryptoIcon symbol={crypto.symbol} size={24} />
                <span className="crypto-symbol">{crypto.symbol}</span>
                <span className="crypto-price">
                  ${crypto.price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
                <span className={`crypto-change ${crypto.change24h >= 0 ? 'positive' : 'negative'}`}>
                  {crypto.change24h >= 0 ? '↑' : '↓'} 
                  {Math.abs(crypto.change24h).toFixed(2)}%
                </span>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CryptoTicker;